export enum MessageRequestType {
  Thread = 'Thread',
  Assistant = 'Assistant',
  Summary = 'Summary',
}
